import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Slider } from 'antd'
import AddPackages from '../../../components/Main/Tracking/AddPackages/AddPackages'
import AWBPull from '../../../components/Main/Tracking/AWBPull'
import ContactDetails from '../../../elements/ContactDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import withKeyValue from '../../../elements/HOC/WithKeyValue'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import useModalShow from '../../../elements/Hooks/useModalShow'
import CustomSelect from '../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withData from '../../../elements/Select/withData'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import CustomTable from '../../../elements/Table/CustomTable'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../modules/FormItems'
import { dateVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import { compose } from 'recompose'

const TypeSelect = compose(
  withData({
    data: [
      { key: 'master', value: 'Master Tracking Number' },
      { key: 'sub', value: 'Sub Tracking Number' },
    ],
  }),
)(CustomSelect)

const StatusType = compose(
  withSelectFetch({ dropdown: 'tracking', name: 'status' }),
  withSpinning,
  withKeyValue(),
  withSort,
)(CustomSelect)

const CarrierType = compose(
  withSelectFetch({ dropdown: 'tracking', name: 'carrier' }),
  withSpinning,
  withKeyValue(),
  withSort,
)(CustomSelect)

function TrackingForm (props) {
  const { tracking, fetch, fetching, getRandHex } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form
  const type = getFieldValue('type') || get(tracking, 'type')
  const isMaster = type === 'master'
  const sendEmail = getFieldValue('sendEmail')

  let company = getFieldValue('company._id') || get(tracking, 'company._id')
  company = company && company.replace('members/', '')

  const [trackNumber] = useState(`TK20-${getRandHex()}-${getRandHex()}`)
  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Package Info', accessor: 'info' },
    // { Header: 'Track Link', accessor: 'link' },
  ]
  const packages = get(tracking, 'packages', [])
  const { visible, onShow, onCancel, payload } = useModalShow()
  const [sales, setSales] = useState({})

  useEffect(() => {
    if (sendEmail) {
      console.log(get(sales, 'delivery.notify.notify', '_'))
      setFieldsValue({
        'salesRep.company._id': get(sales, 'client.member._id'),
        'salesRep.notify._id': get(sales, 'clientRep._id'),
      })

      if (get(sales, 'delivery.notify.notify._id')) {
        setFieldsValue({
          'logisticCoordinator.company._id': get(sales, 'client.member._id'),
          'logisticCoordinator.notify._id': get(sales, 'delivery.notify.notify._id'),
        })
      }
    }
  }, [sales, sendEmail])

  const [SalesSelect] = useFetchSelectUrl(
    {
      name: 'sales',
      url: `sales/?select=_id,code,title,client,clientRep,delivery&company=${company}`,
      cache: true,
    },
    [company],
    isEmpty(company),
    Select,
    (c) => ({ ...c, display: `[${c.code}]  ${c.title}` }),
  )

  const [TrackingOrderSelect] = useFetchSelectUrl(
    {
      name: 'tracking',
      url: `tracking/?select=*&type=master`,
      cache: true,
    },
    [type],
    isEmpty(type),
    Select,
    (c) => ({ ...c, display: `[${c.trackingNumber}]  ${c.sales.code}` }),
  )

  const [CompanyRepSelect] = useFetchSelectUrl(
    {
      name: 'companyRep',
      url: `members/${company}/representatives`,
      cache: true,
      forceFetch: true,
    },
    [company],
    isEmpty(company),
  )

  const carrier = getFieldValue('carrier') || get(tracking, 'carrier')
  const track = getFieldValue('ref') || get(tracking, 'ref')

  return (
    <Row>
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Type">
              {getFieldDecorator('type', {
                initialValue: get(tracking, 'type') || 'master',
                rules: rules.select,
              })(<TypeSelect/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Tracking Number">
              {getFieldDecorator('trackingNumber', {
                initialValue: get(tracking, 'trackingNumber') || trackNumber,
                rules: rules.input,
              })(<Input style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Date">
              {getFieldDecorator('date', {
                initialValue: dateVal(tracking, 'date') || moment(),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          {!isMaster && (
            <>
              <Col span={24}>
                <Form.Item {...fullWidthFormItemLayout} label="Master Tracking Order">
                  {getFieldDecorator('master._id', {
                    initialValue: get(tracking, 'master._id'),
                    rules: rules.date,
                  })(<TrackingOrderSelect keyAtr={'_id'} valueAtr={'display'}/>)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Carrier">
                  {getFieldDecorator('carrier', {
                    initialValue: get(tracking, 'carrier'),
                    rules: rules.input,
                  })(<CarrierType style={{ width: '100%' }}/>)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="AWB/BOL">
                  {getFieldDecorator('ref', {
                    initialValue: get(tracking, 'ref'),
                    rules: rules.input,
                  })(<Input style={{ width: '80%' }}/>)}
                  <AWBPull {...{ carrier, track }} />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>

        <Row>
          <>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Company">
                {getFieldDecorator('company._id', {
                  initialValue: get(tracking, 'company._id'),
                  rules: rules.select,
                })(<OrganisationsSelect disabled={!isMaster}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              {company && (
                <Form.Item {...defaultFormItemLayout} label="Company Rep">
                  {getFieldDecorator('companyRep._id', {
                    initialValue: get(tracking, 'companyRep._id'),
                    rules: rules.select,
                  })(
                    <CompanyRepSelect
                      placeholder="Received By"
                      keyAtr={'_id'}
                      disabled={!isMaster}
                      valueAtr={'name'}
                      style={{ width: '100%' }}
                    />,
                  )}
                </Form.Item>
              )}
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Select a Sales">
                {getFieldDecorator('sales._id', {
                  initialValue: get(tracking, 'sales._id'),
                  rules: rules.select,
                })(<SalesSelect setSelected={setSales} disabled={!isMaster} keyAtr={'_id'} valueAtr={'display'}/>)}
              </Form.Item>
            </Col>
          </>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Status">
              {getFieldDecorator('status', {
                initialValue: get(tracking, 'status'),
                rules: rules.select,
              })(<StatusType/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Completion Percent">
              {getFieldDecorator('percent', {
                initialValue: get(tracking, 'percent'),
                rules: rules.input,
              })(<Slider tipFormatter={(value) => `${value} %`} tooltipVisible style={{ width: '80%' }}/>)}
            </Form.Item>
          </Col>
          <Col span={12} style={{ align: 'center' }}>
            <Form.Item
              {...defaultFormItemLayout}
              label="Send Notification"
              style={{ fontWeight: 'bold', color: 'red' }}>
              {getFieldDecorator('sendEmail', {
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
        </Row>
        {sendEmail && (
          <Row>
            <ContactDetails
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                title: 'Sales Rep',
                doc: tracking,
                isMember: false,
                require: false,
                prefix: 'salesRep',
                hide: ['country', 'address', 'phone'],
              }}
            />
            <ContactDetails
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                title: 'Logistic Coordinator',
                doc: tracking,
                isMember: false,
                require: false,
                prefix: 'logisticCoordinator',
                hide: ['country', 'address', 'phone'],
              }}
            />
          </Row>
        )}

        {!isMaster && (
          <Row>
            <FormSectionTitle title={'Packages'}/>
            <CustomTable
              CreateButton={() => (
                <Button type="primary" onClick={onShow}>
                  New Packages
                </Button>
              )}
              fetch={fetch}
              loading={fetching}
              columns={columns}
              data={packages}
            />
            <AddPackages
              {...{
                payload,
                tracking,
                fetching,
                fetch,
                visible,
                onShow,
                onCancel,
              }}
            />
          </Row>
        )}
      </Form>
    </Row>
  )
}

TrackingForm.propTypes = {}
TrackingForm.defaultProps = {}

export default Form.create()((TrackingForm))
